import React, { Component } from 'react';
import { connect } from 'react-redux';
import { I18n } from 'react-redux-i18n';
import { css } from 'aphrodite/no-important';
import styles from './Triggers.styles';
import {
  getWorkflowAction,
  editWorkflowAction,
  getTriggersAction,
  addTriggerAction,
  editTriggerAction,
  deleteTriggerAction,
  setCurrentTriggerAction,
  getActionsAction,
  addActionAction,
  editActionAction,
  deleteActionAction,
  setCurrentActionAction
} from '../../reducers/actions';
import { CRITERIA_TAG_TYPES, ACTION_OPTIONS } from '../../constants/triggers';
import Confirm from '../../components/common/confirm/Confirm';
import Modal from '../../components/common/modal/Modal';
import TitleBar from '../../components/common/titlebar/TitleBar';
import AddTriggerForm from '../../components/forms/addtriggerform/AddTriggerForm';
import AddActionForm from '../../components/forms/addactionform/AddActionForm';
import TriggerList from '../../components/data/triggerlist/TriggerList';

export class Triggers extends Component {
  state = {
    loading: true,
    showModal: false,
    showEditModal: false,
    showDeleteModal: false,
    showAddActionModal: false,
    showEditActionModal: false,
    showDeleteActionModal: false,
    currentTrigger: null,
    currentAction: null
  };
  componentDidMount() {
    if (this.props.account && this.props.currentSite) {
      this.props.getWorkflow(this.props.match.params.id);
      this.props.getTriggers(
        this.props.currentSite,
        this.props.match.params.id
      );
      this.setState({ loading: false });
    }
  }
  componentWillUpdate(nextProps) {
    if (this.state.loading && nextProps.account && nextProps.currentSite) {
      this.props.getWorkflow(nextProps.match.params.id);
      this.props.getTriggers(
        nextProps.currentSite.id,
        nextProps.match.params.id
      );
      this.setState({ loading: false });
    }
  }
  handleClose = () => {
    this.setState({
      showModal: false,
      showEditModal: false,
      showDeleteModal: false,
      showAddActionModal: false,
      showEditActionModal: false,
      showDeleteActionModal: false
    });
  };
  handleAdd = () => {
    this.props.setCurrentTrigger({});
    this.setState({ showModal: true });
  };
  handleEdit = trigger => {
    this.props.setCurrentTrigger(trigger);
    this.setState({ showEditModal: true });
  };
  handleDelete = trigger => {
    this.setState({ showDeleteModal: true, currentTrigger: trigger });
  };
  handleAddSubmit = values => {
    values.workflow = this.props.currentWorkflow;
    values.site = this.props.currentSite;
    this.props.addTrigger(values);
    this.handleClose();
  };
  handleEditSubmit = values => {
    this.props.editTrigger(values);
    this.handleClose();
  };
  handleDeleteSubmit = () => {
    this.props.deleteTrigger(this.state.currentTrigger);
    this.handleClose();
  };

  handleAddAction = trigger => {
    this.props.setCurrentAction({ trigger });
    this.setState({ showAddActionModal: true });
  };
  handleEditAction = action => {
    this.props.setCurrentAction(action);
    this.setState({ showEditActionModal: true });
  };
  handleDeleteAction = action => {
    this.setState({ showDeleteActionModal: true, currentAction: action });
  };
  handleAddActionSubmit = values => {
    this.props.addAction(values);
    this.handleClose();
  };
  handleEditActionSubmit = values => {
    this.props.editAction(values);
    this.handleClose();
  };
  handleDeleteActionSubmit = () => {
    this.props.deleteAction(this.state.currentAction);
    this.handleClose();
  };

  handleEditWorkflow = name => {
    this.props.editWorkflow({
      ...this.props.currentWorkflow,
      name
    });
  };
  render() {
    return (
      <section className={css(styles.base)}>
        {this.props.currentWorkflow &&
          this.props.currentWorkflow.name && (
            <TitleBar
              title={this.props.currentWorkflow.name}
              btn={I18n.t('add.triggers.add')}
              editable={true}
              handleAdd={this.handleAdd}
              handleEdit={this.handleEditWorkflow}
            />
          )}
        <TriggerList
          data={this.props.triggers}
          handleAdd={this.handleAdd}
          handleAddAction={this.handleAddAction}
          addText={I18n.t('add.triggers.add')}
          onEdit={this.handleEdit}
          onDelete={this.handleDelete}
          onEditAction={this.handleEditAction}
          onDeleteAction={this.handleDeleteAction}
        />
        <Modal
          isOpen={this.state.showModal || this.state.showEditModal}
          onRequestClose={this.handleClose}
          contentLabel="Add Trigger"
          title={I18n.t('add.triggers.trigger')}
          styles={{ base: styles.modal }}
        >
          <AddTriggerForm
            onSubmit={
              !this.state.showEditModal
                ? this.handleAddSubmit
                : this.handleEditSubmit
            }
            onCancel={this.handleClose}
            initialValues={this.props.currentTrigger}
          />
        </Modal>

        <Modal
          isOpen={
            this.state.showEditActionModal || this.state.showAddActionModal
          }
          onRequestClose={this.handleClose}
          contentLabel="Add Action"
          title={I18n.t('add.actions.action')}
          styles={{ base: styles.modal }}
        >
          <AddActionForm
            onSubmit={
              !this.state.showEditActionModal
                ? this.handleAddActionSubmit
                : this.handleEditActionSubmit
            }
            onCancel={this.handleClose}
            initialValues={this.props.currentAction}
          />
        </Modal>
        <Modal
          isOpen={this.state.showDeleteModal}
          onRequestClose={this.handleClose}
          contentLabel="Delete Trigger"
          title={I18n.t('delete.deleteTrigger')}
        >
          <Confirm
            itemName={
              this.state.currentTrigger && this.state.currentTrigger.name
            }
            confirm={this.handleDeleteSubmit}
            deny={this.handleClose}
          />
        </Modal>
        <Modal
          isOpen={this.state.showDeleteActionModal}
          onRequestClose={this.handleClose}
          contentLabel="Delete Action"
          title={I18n.t('delete.deleteAction')}
        >
          <Confirm
            itemName={
              this.state.currentAction &&
              I18n.t(ACTION_OPTIONS[this.state.currentAction.type].text, {
                customValue: this.state.currentAction.value
              })
            }
            confirm={this.handleDeleteActionSubmit}
            deny={this.handleClose}
          />
        </Modal>
      </section>
    );
  }
}

const mapStateToProps = ({
  auth: { account },
  workflows: { currentWorkflow },
  triggers: { list: triggers, currentTrigger },
  actions: { list: actions, currentAction },
  sites: { currentSite, list: sites },
  areas: { list: areas },
  zones: { list: zones },
  locations: { list: locations },
  categories: { list: categories },
  groups: { list: groups }
}) => {
  const getObjectFromList = (id, prop) => {
    if (!id) {
      return '';
    }
    let list = [];
    switch (prop) {
      case CRITERIA_TAG_TYPES.SITE: {
        list = sites;
        break;
      }
      case CRITERIA_TAG_TYPES.AREA: {
        list = areas;
        break;
      }
      case CRITERIA_TAG_TYPES.ZONE: {
        list = zones;
        break;
      }
      case CRITERIA_TAG_TYPES.LOCATION: {
        list = locations;
        break;
      }
      case CRITERIA_TAG_TYPES.CATEGORY: {
        list = categories;
        break;
      }
      case CRITERIA_TAG_TYPES.GROUP: {
        list = groups;
        break;
      }
      default:
        return { name: id };
    }
    return list.find(item => item.id === id);
  };
  return {
    account,
    currentAction,
    currentTrigger,
    currentWorkflow,
    currentSite,
    triggers: triggers
      ? triggers.map(trigger => ({
          ...trigger,
          criteria: trigger.criteria.map(criteria => ({
            ...criteria,
            compareTo: getObjectFromList(
              criteria.compareTo.id,
              criteria.property
            )
          }))
        }))
      : []
  };
};

const mapDispatchToProps = dispatch => {
  return {
    getWorkflow() {
      dispatch(getWorkflowAction(...arguments));
    },
    editWorkflow() {
      dispatch(editWorkflowAction(...arguments));
    },
    getTriggers() {
      dispatch(getTriggersAction(...arguments));
    },
    setCurrentTrigger() {
      dispatch(setCurrentTriggerAction(...arguments));
    },
    addTrigger() {
      dispatch(addTriggerAction(...arguments));
    },
    editTrigger() {
      dispatch(editTriggerAction(...arguments));
    },
    deleteTrigger() {
      dispatch(deleteTriggerAction(...arguments));
    },
    getActions() {
      dispatch(getActionsAction(...arguments));
    },
    addAction() {
      dispatch(addActionAction(...arguments));
    },
    editAction() {
      dispatch(editActionAction(...arguments));
    },
    deleteAction() {
      dispatch(deleteActionAction(...arguments));
    },
    setCurrentAction() {
      dispatch(setCurrentActionAction(...arguments));
    }
  };
};

export default connect(mapStateToProps, mapDispatchToProps)(Triggers);



// WEBPACK FOOTER //
// ./src/containers/triggers/Triggers.js